import React from 'react';

export default () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
    <div className="container mx-auto px-4 py-16 max-w-4xl">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Política de Privacidade
        </h1>
        <div className="w-24 h-1 bg-gradient-to-r from-purple-600 to-blue-600 mx-auto mb-6"></div>
        <p className="text-xl text-gray-600">
          Academia de Especialistas
        </p>
      </div>

      {/* Content */}
      <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
        
        {/* Seção 1 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
            Informações Gerais
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              A presente Política de Privacidade contém informações sobre coleta, uso, armazenamento, 
              tratamento e proteção dos dados pessoais dos usuários do aplicativo <strong>ACADEMIA DE ESPECIALISTAS</strong>, 
              com a finalidade de demonstrar absoluta transparência quanto ao assunto e esclarecer a todos 
              interessados sobre os tipos de dados que são coletados, os motivos da coleta e a forma como 
              os usuários podem gerenciar ou excluir as suas informações pessoais.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Esta Política de Privacidade aplica-se a todos os usuários do aplicativo <strong>ACADEMIA DE ESPECIALISTAS</strong> 
              e integra os Termos e Condições Gerais de Uso, devidamente inscrita no <strong>CNPJ sob o nº 38.212.806/0001-16</strong>, 
              situado em Avenida Armando Lombardi 1000 – bloco 01 – sala 219, doravante nominada 
              <strong> PAD MED ENSINO EM MEDICINA LTDA</strong>.
            </p>
            <p className="text-gray-700 leading-relaxed">
              O presente documento foi elaborado em conformidade com a Lei Geral de Proteção de Dados Pessoais 
              (Lei 13.709/18), o Marco Civil da Internet (Lei 12.965/14) e o Regulamento da UE n. 2016/6790. 
              Ainda, o documento poderá ser atualizado em decorrência de eventual atualização normativa, 
              razão pela qual se convida o usuário a consultar periodicamente esta seção.
            </p>
          </div>
        </section>

        {/* Seção 2 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
            Como Recolhemos os Dados Pessoais?
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Os dados pessoais do usuário são recolhidos pela plataforma da seguinte forma:
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                Ao adquirir o curso ACADEMIA DE ESPECIALISTAS na plataforma Hotmart, a plataforma do aplicativo 
                se comunica através de um webhook. Webhook é uma forma de recebimento de informações. É uma maneira 
                prática para um app ou sistema fornecer outras aplicações com informações em tempo real.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 3 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
            Quais Dados Pessoais Recolhemos?
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Os seguintes dados pessoais do usuário são recolhidos:
            </p>
            <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                No momento da aquisição do curso, quatro informações são repassadas pelo Hotmart que possibilitam 
                o usuário a se logar no app. São elas: <strong>nome</strong>, <strong>e-mail</strong>, 
                <strong> senha</strong> e o <strong>nome do curso comprado</strong>. Essa última informação 
                determina o nível de acesso ao conteúdo do aplicativo. Já dentro do aplicativo, mais duas 
                informações são coletadas: o <strong>nome da Unidade da Federação</strong> e o 
                <strong> nome do Serviço de Residência</strong> que o usuário pertence.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 4 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
            Para Que Finalidades Utilizamos os Dados?
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              Os dados pessoais do usuário coletados e armazenados pela plataforma têm por finalidade:
            </p>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-purple-50 p-6 rounded-lg">
                <h4 className="font-semibold text-purple-800 mb-3">Bem-estar do usuário</h4>
                <p className="text-gray-700 text-sm">
                  Aprimorar o produto e/ou serviço oferecido, facilitar, agilizar e cumprir os compromissos 
                  estabelecidos entre o usuário e a empresa.
                </p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg">
                <h4 className="font-semibold text-blue-800 mb-3">Melhorias da plataforma</h4>
                <p className="text-gray-700 text-sm">
                  Compreender como o usuário utiliza os serviços da plataforma, para ajudar no desenvolvimento 
                  de negócios e técnicas.
                </p>
              </div>
              <div className="bg-green-50 p-6 rounded-lg">
                <h4 className="font-semibold text-green-800 mb-3">Comercial</h4>
                <p className="text-gray-700 text-sm">
                  Os dados são usados para personalizar o conteúdo oferecido e gerar subsídio à plataforma 
                  para a melhora da qualidade no funcionamento dos serviços.
                </p>
              </div>
              <div className="bg-orange-50 p-6 rounded-lg">
                <h4 className="font-semibold text-orange-800 mb-3">Previsão do perfil</h4>
                <p className="text-gray-700 text-sm">
                  Tratamento automatizado de dados pessoais para avaliar o uso na plataforma.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Seção 5 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
            Por Quanto Tempo os Dados Ficam Armazenados?
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Os dados pessoais do usuário são armazenados pela plataforma durante o período necessário para 
              a prestação do serviço ou o cumprimento das finalidades previstas no presente documento, 
              conforme o disposto no inciso I do artigo 15 da Lei 13.709/18.
            </p>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                Os dados podem ser removidos ou anonimizados a pedido do usuário, excetuando os casos em que 
                a lei oferecer outro tratamento. No caso de solicitação de remoção dos dados impossibilitará 
                a utilização do aplicativo. Nenhum reembolso será devido, uma vez que o app é uma disponibilidade 
                gratuita aos usuários que comprarem o curso ACADEMIA DE ESPECIALISTAS.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 6 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
            Segurança dos Dados Pessoais
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              A plataforma se compromete a aplicar as medidas técnicas e organizativas aptas a proteger os 
              dados pessoais de acessos não autorizados e de situações de destruição, perda, alteração, 
              comunicação ou difusão de tais dados.
            </p>
            <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                A plataforma se exime de responsabilidade por culpa exclusiva de terceiros, como em caso de 
                ataque de hackers ou crackers, ou culpa exclusiva do usuário, como no caso em que ele mesmo 
                transfere seus dados a terceiros. O site se compromete a comunicar o usuário em caso de alguma 
                violação de segurança dos seus dados pessoais.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 7 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
            Compartilhamento dos Dados
          </h2>
          <div className="prose prose-lg max-w-none">
            <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                Os dados do perfil do usuário <strong>não são compartilhados</strong>.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 8 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">8</span>
            Transferência a Terceiros
          </h2>
          <div className="prose prose-lg max-w-none">
            <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                Os dados pessoais <strong>não serão compartilhados com terceiros</strong>.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 9 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">9</span>
            Cookies e Dados de Navegação
          </h2>
          <div className="prose prose-lg max-w-none">
            <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                O aplicativo <strong>não utiliza cookies</strong> e <strong>não coleta dados de navegação</strong>.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 10 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">10</span>
            Consentimento
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Ao utilizar os serviços e fornecer as informações pessoais na plataforma, o usuário está 
              consentindo com a presente Política de Privacidade.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              O usuário, ao cadastrar-se, manifesta conhecer e pode exercitar seus direitos de cancelar 
              seu cadastro, acessar e atualizar seus dados pessoais e garante a veracidade das informações 
              por ele disponibilizadas.
            </p>
            <div className="bg-orange-50 border-l-4 border-orange-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                O usuário tem direito de retirar o seu consentimento a qualquer tempo, para tanto deve 
                entrar em contato através do perfil da empresa no Instagram. A retirada do consentimento 
                implicará, necessariamente, a perda de acesso ao aplicativo e a plataforma.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 11 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">11</span>
            Alterações na Política de Privacidade
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Reservamos o direito de modificar essa Política de Privacidade a qualquer momento, então, 
              é recomendável que o usuário e visitante revise-a com frequência.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              As alterações e esclarecimentos vão surtir efeito imediatamente após sua publicação na 
              plataforma. Quando realizadas alterações os usuários serão notificados. Ao utilizar o 
              serviço ou fornecer informações pessoais após eventuais modificações, o usuário e visitante 
              demonstra sua concordância com as novas normas.
            </p>
            <div className="bg-purple-50 border-l-4 border-purple-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                Diante da fusão ou venda da plataforma à outra empresa os dados dos usuários podem ser 
                transferidos para os novos proprietários para que a permanência dos serviços oferecidos.
              </p>
            </div>
          </div>
        </section>

        {/* Seção 12 */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">12</span>
            Jurisdição para Resolução de Conflitos
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-4">
              Para a solução de controvérsias decorrentes do presente instrumento será aplicado 
              integralmente o Direito brasileiro.
            </p>
            <div className="bg-gray-50 border-l-4 border-gray-400 p-6 rounded-r-lg">
              <p className="text-gray-700 leading-relaxed">
                Os eventuais litígios deverão ser apresentados no foro da comarca em que se encontra 
                a sede da empresa, ou seja na capital do Estado do Rio de Janeiro.
              </p>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="border-t border-gray-200 pt-8 mt-12">
          <div className="text-center">
            <p className="text-gray-600 text-sm">
              Última atualização: Janeiro 2025
            </p>
            <p className="text-gray-500 text-xs mt-2">
              PAD MED ENSINO EM MEDICINA LTDA - CNPJ: 38.212.806/0001-16
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
);
